// The app's sections: sidebar entries, drawer entries, bottom tabs and app-bar titles all derive
// from this single list so they stay in sync.

import { ClipboardList, Package, ScanQrCode, Settings2, Truck } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface Section {
  href: string;
  label: string;
  /** Bottom-tab label when the full one is too long for a phone. */
  short?: string;
  icon: LucideIcon;
  /** Gate admins only. */
  adminOnly?: boolean;
  /** The big round tab in the phone bottom bar. */
  prominent?: boolean;
}

export const SECTIONS: Section[] = [
  { href: "/", label: "Today at the gate", short: "Today", icon: Truck },
  { href: "/scan", label: "Scan gate pass", short: "Scan", icon: ScanQrCode, prominent: true },
  { href: "/orders", label: "Open orders", short: "Orders", icon: Package },
  { href: "/log", label: "Consignment log", short: "Log", icon: ClipboardList },
  { href: "/admin", label: "Gates & guards", short: "Admin", icon: Settings2, adminOnly: true },
];

export const APP_NAME = "RGSEVA Gate";

export function visibleSections(isAdmin: boolean): Section[] {
  return SECTIONS.filter((s) => !s.adminOnly || isAdmin);
}

export function isActive(pathname: string, href: string): boolean {
  return href === "/" ? pathname === "/" : pathname === href || pathname.startsWith(`${href}/`);
}

/** App-bar title for the current route. */
export function sectionTitle(pathname: string): string {
  if (pathname.startsWith("/order/")) return "Order at the gate";
  return SECTIONS.find((s) => isActive(pathname, s.href))?.label ?? APP_NAME;
}
